import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppKitService } from '../services/ appkit.service';

export const adminAuthGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const appKitService = inject(AppKitService);
  await appKitService.whenReady();

  const account = appKitService.getResolvedAccount();
  if (account) {
    return true;
  }
  return router.createUrlTree(['/login']);
};
